<template>
    <v-card
            class="mx-auto donationleaderboard"
            max-width="360"
            :dark="isDark"



    >

                <v-list :dark="isDark" >
                    <v-list-item>
                        <v-list-item-title style="text-align: center;">Top Collectors</v-list-item-title>
                    </v-list-item>
                    <v-list-item
                            v-for="(owner, i) in card_owners"
                            :key="i"
                            :dark="isDark"
                            :style="{'background':colors[!isDark? 1 : 0][i % 2]}"
                            link
                            :to="'/inventory/'+collection_data[owner.toString()].sid"

                    >
                        <v-avatar class="mr-1 ml-0" size="30">
                            <img :src="'/api/images/users/'+collection_data[owner.toString()].sid+'.png'" @error="function(e){replaceByDefault(e,collection_data[owner.toString()].username)}"  >
                        </v-avatar>
                        <v-chip small label class="mr-1">{{collection_data[owner.toString()].username}}</v-chip>

                        <v-spacer></v-spacer>
                        <v-chip small class="white--text mx-1" label color="green">
                            {{collection_data[owner.toString()].common}}
                        </v-chip>
                        <v-chip small label class="white--text mx-1" color="blue">
                            {{collection_data[owner.toString()].rare}}

                        </v-chip>
                        <v-chip small label class="white--text mx-1" color="purple">
                            {{collection_data[owner.toString()].epic}}

                        </v-chip>
                        <v-chip small label class="white--text mx-1" color="orange">
                            {{collection_data[owner.toString()].legendary}}

                        </v-chip>
                    </v-list-item>

                </v-list>



    </v-card>
</template>

<script>
    export default {
        name: "HicardsLeaderboard",
        props:["local","isDark"],
        data(){
            return{
                card_owners:[],
                collection_data:{},
                colors:[["rgba(45,45,45,0.8)","rgba(36,36,36,0.8)"],["rgba(240,240,240,1)","rgba(250,250,250,1)"]]


            }
        },
        methods:{
            replaceByDefault(e,username){
                e.target.src = `/api/avatar/${username.toLowerCase()}`
            },


            getData(){

                let http = new XMLHttpRequest();
                http.withCredentials = true;
                let id=window.location.pathname.substring(1);
                let url="/api/get_collector_stats"
                if(this.local){
                    url = '/api/get_collector_stats?&id='+id;
                }
                http.open('GET', url, true);
                http.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');
                let self=this;
                http.onreadystatechange = function() {
                    if(http.readyState === 4 && http.status === 403) {
                        console.log("error");
                    }
                    else if(http.readyState === 4 && http.status === 200){
                        if(http.responseText!=="no data"){
                            let datap = JSON.parse(http.response);
                            self.orderData(datap);
                        }

                    }
                };
                http.send();


            },
            orderData:function(data){
                let dataObj={};
                for(let i=0;i<data.length;i++){
                    if(dataObj[data[i].SID]===undefined){
                        dataObj[data[i].SID]={sid:data[i].SID,points:0,common:0,rare:0,epic:0,legendary:0,total:0,username:data[i].USER_NAME}
                    }
                    if(data[i].RANK_VALUE===0){
                        dataObj[data[i].SID]["common"]+=data[i].COUNTED;
                        dataObj[data[i].SID]["total"]+=data[i].COUNTED;
                        dataObj[data[i].SID]["points"]+=data[i].COUNTED*1;
                    }

                    else if(data[i].RANK_VALUE===1){
                        dataObj[data[i].SID]["rare"]+=data[i].COUNTED;
                        dataObj[data[i].SID]["total"]+=data[i].COUNTED;
                        dataObj[data[i].SID]["points"]+=data[i].COUNTED*1.28;
                    }

                    else if(data[i].RANK_VALUE===2){
                        dataObj[data[i].SID]["epic"]+=data[i].COUNTED;
                        dataObj[data[i].SID]["total"]+=data[i].COUNTED;
                        dataObj[data[i].SID]["points"]+=data[i].COUNTED*3;
                    }

                    else if(data[i].RANK_VALUE===3){
                        dataObj[data[i].SID]["legendary"]+=data[i].COUNTED;
                        dataObj[data[i].SID]["total"]+=data[i].COUNTED;
                        dataObj[data[i].SID]["points"]+=data[i].COUNTED*9;
                    }
                }

                let keysSorted = Object.keys(dataObj).sort(function(a,b){return dataObj[a].points-dataObj[b].points});
                keysSorted=keysSorted.reverse();
                this.card_owners=keysSorted.splice(0,10);
                this.collection_data=dataObj;
                //this.setupData(dataObj,keysSorted)

            },
            colorMe(amount){
                if(parseInt(amount)>499){
                    return "orange"
                }
                else if(parseInt(amount)>99){
                    return "purple"
                }
                else if(parseInt(amount)>49){
                    return "blue"
                }
                else if(parseInt(amount)>20){
                    return "green"
                }
                else{
                    return "#3f3f3f"
                }
            },

        },
        mounted:function(){
            this.getData();


        }
    }
</script>

<style scoped>





</style>
